import React from "react";
import { ExternalLink } from "lucide-react";
import { fmt } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const money = (v, cur = "AUD") => fmt(v || 0, cur);

export function SourceLink({ docId, testid = "view-source" }) {
  if (!docId) return null;
  return (
    <a data-testid={testid} href={`${BACKEND}/api/documents/${docId}/file`} target="_blank" rel="noreferrer"
      className="inline-flex items-center gap-1.5 text-[#8a6d2f] hover:underline text-sm">
      <ExternalLink size={13} /> View Source Document
    </a>
  );
}

export function SectionCard({ title, action, children, className = "" }) {
  return (
    <div className={`glass-card rounded-2xl p-6 ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-5">
          {title && <h3 className="font-display text-xl text-[#2C2A28]">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function Stat({ label, value, accent = "#2C2A28", testid }) {
  return (
    <div className="bg-white/60 border border-[#EAE0D2] rounded-xl px-4 py-3" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.12em] text-[#8A7F70]">{label}</div>
      <div className="font-mono-data text-lg mt-1" style={{ color: accent }}>{value}</div>
    </div>
  );
}

export function KV({ label, value }) {
  return (
    <div className="flex justify-between gap-4 border-b border-[#F0E9DD] py-2 text-sm">
      <span className="text-[#8A7F70]">{label}</span>
      <span className="text-[#2C2A28] text-right">{value || "—"}</span>
    </div>
  );
}

export const OCC_COLORS = {
  "Tenanted": "#8FB996", "Owner Occupied": "#9FB8C9", "Vacant": "#C99FA0",
  "Listed for Rent": "#C6A45C", "Under Renovation": "#B79B86",
};
